import { Navigate, Route, Routes } from 'react-router';
import { Trans } from '@lingui/react/macro';

import { SettingsSectionLayout } from '../../../components/Layout/Layout';

import { CompaniesRoutes } from './subsections/Companies/Companies';

export const Invoicing = () => {
  return (
    <SettingsSectionLayout
      title={<Trans id="settings-section.billing">Billing</Trans>}
      tabs={[
        {
          id: 'companies',
          label: <Trans id="settings.organization.invoicing.companies">Companies</Trans>,
        },
      ]}
    >
      <Routes>
        <Route path="" element={<Navigate to="/settings_beta/billing/companies" replace />} />
        <Route path="companies/*" element={<CompaniesRoutes />} />
        <Route path="*" element={<Navigate to="/settings_beta/billing/companies" replace />} />
      </Routes>
    </SettingsSectionLayout>
  );
};
